import { createReducer, on } from '@ngrx/store';
import { driverLicenseActions } from '../driver_license.actions';

export interface DlDownloadState {
    links: string[];
}

export const initialState: DlDownloadState = { links: [] };

export const dlDownloadReducer = createReducer(
    initialState,
    on(driverLicenseActions.downloadSuccess, (state, { payload }) => ({ ...state, links: payload })),
    on(driverLicenseActions.clearDownload, () => initialState)
);
